import React from "react";

const NewsEvents = () => {
  const posts = [
    {
      img: "https://everymatrix.com/wp-content/uploads/2025/04/1-What-Is-a-Casino-Loyalty-Program-1024x538.png",
      alt: "Featured image of an informational article about what is a casino loyalty program",
      date: "April 25, 2025",
      categories: ["Articles"],
      title: "What is a casino loyalty program? An introduction",
      url: "https://everymatrix.com/what-is-a-casino-loyalty-program/",
    },
    {
      img: "https://everymatrix.com/wp-content/uploads/2025/04/stian-april-2-fixed-1024x538.png",
      alt: "",
      date: "April 24, 2025",
      categories: ["News", "Interviews"],
      title:
        "Absence of synchronised gamification tools across content providers",
      url: "https://everymatrix.com/everymatrix-effect-synchronised-gamification-tools-absence/",
    },
    {
      img: "https://everymatrix.com/wp-content/uploads/2025/04/1-The-Ultimate-Guide-to-Casino-Loyalty-Programs-1-1024x538.png",
      alt: "Casino loyalty programs guide cover image with golden reward stars.",
      date: "April 14, 2025",
      categories: ["News", "Articles"],
      title:
        "The ultimate guide to casino loyalty programs: Boost engagement & retention",
      url: "https://everymatrix.com/casino-loyalty-programs-guide/",
    },
    {
      img: "https://everymatrix.com/wp-content/uploads/2025/03/The-impact-of-reporting-options-1024x538.png",
      alt: "",
      date: "March 13, 2025",
      categories: ["News", "Interviews"],
      title: "The impact of reporting options on operators’ operations",
      url: "https://everymatrix.com/the-impact-of-reporting-options-on-operators-operations/",
    },
  ];

  return (
    <>
      <section className="news sec-padd">
        <div className="container container_custom">
          <div className="row">
            <div className="col-md-12">
              <h2 className="section-title">Latest News &amp; Events</h2>
              <div className="list-posts">
                <div className="row g-4">
                  {posts.map((post, index) => (
                    <div className="col-lg-3 col-md-4 col-sm-6" key={index}>
                      <div className="post">
                        <a href={post.url} className="img-holder">
                          <img
                            src={post.img}
                            alt={post.alt}
                            className="attachment-large size-large wp-post-image"
                            loading="lazy"
                          />
                        </a>
                        <div className="inner">
                          <div className="meta">
                            <time>{post.date}</time>
                            {post.categories.map((cat, i) => (
                              <a
                                // href={`https://everymatrix.com/category/${cat.toLowerCase()}/`}
                                key={i}
                              >
                                {cat}
                              </a>
                            ))}
                          </div>
                          <h3>
                            <a
                              // href={post.url}
                              data-ga-click="news-post"
                            >
                              {post.title}
                            </a>
                          </h3>
                          <a
                            // href={post.url}
                            className="read-more"
                            data-ga-click="news-post"
                          >
                            Read more
                          </a>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="row pt-5 mt-5">
                <div className="col-md-12 text-center">
                  <a
                    // href="https://everymatrix.com/news/"
                    className="btn btn_blue"
                  >
                    See all the latest news &amp; events
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default NewsEvents;
